import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import { decode, decompress } from 'utils/upload/decompressionUtils';
import SampleValidationError from 'utils/errors/upload/SampleValidationError';
var columnsToSearch = [['Cell_Index'], ['Bioproduct', 'Gene'], ['DBEC_Adjusted_Molecules', 'RSEC_Adjusted_Molecules']];
var validateRhapsody = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(sample) {
    var _sample$files$rhapsod, compressed, fileObject, fileArrBuffer, file, missingColumns;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _sample$files$rhapsod = sample.files.rhapsody, compressed = _sample$files$rhapsod.compressed, fileObject = _sample$files$rhapsod.fileObject;
            _context.next = 3;
            return fileObject.slice(0, 800).arrayBuffer();
          case 3:
            fileArrBuffer = _context.sent;
            if (!compressed) {
              _context.next = 14;
              break;
            }
            _context.t1 = decode;
            _context.next = 8;
            return decompress(fileArrBuffer);
          case 8:
            _context.t2 = _context.sent;
            _context.next = 11;
            return (0, _context.t1)(_context.t2);
          case 11:
            _context.t0 = _context.sent;
            _context.next = 17;
            break;
          case 14:
            _context.next = 16;
            return decode(fileArrBuffer);
          case 16:
            _context.t0 = _context.sent;
          case 17:
            file = _context.t0;
            missingColumns = columnsToSearch.some(function (column) {
              return !column.some(function (subColumn) {
                return file.includes(subColumn);
              });
            });
            if (!missingColumns) {
              _context.next = 21;
              break;
            }
            throw new SampleValidationError('.st file does not contain the required columns');
          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function validateRhapsody(_x) {
    return _ref.apply(this, arguments);
  };
}();
export default validateRhapsody;